export class StaleDataError extends Error {
  constructor(payload) {
    super(payload?.message || 'Record was modified by someone else');
    this.name = 'StaleDataError';
    this.entityType = payload?.entityType;
    this.entityId = payload?.entityId;
    this.currentVersion = payload?.currentVersion;
  }
}
